import { render, staticRenderFns } from "./Infor.vue?vue&type=template&id=3162d84f&scoped=true"
import script from "./Infor.vue?vue&type=script&lang=js"
export * from "./Infor.vue?vue&type=script&lang=js"
import style0 from "./Infor.vue?vue&type=style&index=0&id=3162d84f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3162d84f",
  null
  
)

export default component.exports